export const purchaseStatus = {
  FULFILLED: 'FULFILLED',
  AUTO_APPROVED: 'AUTO_APPROVED',
  CANCELLED: 'CANCELLED'
};
